import React from 'react';
import { Box, Divider, Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { getCurrencySymbolFromCurrencyCode } from '@shared/utils/currency/utils';

export const RoomBlockPrice = ({ price, strikeoutPrice, noOfRooms, currency }: { price: number; strikeoutPrice: number; noOfRooms: number; currency?: string }) => {
  const { t } = useTranslation('websiteEditor');
  const hotelTrans = t('customPage', 'travelMap', 'hotel');
  const currencySymbol = getCurrencySymbolFromCurrencyCode(currency);

  return (
    <Box>
      <Flex
        alignItems="center"
        justifyContent="space-between"
      >
        <TextV2 typographyVariant="body1">{hotelTrans.groupRateRooms({ noOfRooms })}</TextV2>
        <TextV2
          typographyVariant="hed6"
          fontWeight={'semibold'}
        >
          {currencySymbol}
          {price}
        </TextV2>
      </Flex>
      {strikeoutPrice > 0 && (
        <>
          <Divider
            marginTop={2}
            marginBottom={3}
          />
          <Flex
            alignItems="center"
            justifyContent="space-between"
          >
            <TextV2 typographyVariant="body1">{hotelTrans.standardPrice()}</TextV2>
            <TextV2
              typographyVariant="body1"
              textDecoration="line-through"
            >
              {currencySymbol}
              {strikeoutPrice}
            </TextV2>
          </Flex>
        </>
      )}
    </Box>
  );
};
